import { useState } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useEditorWebsocket, useCheckEstimateEditorAccess } from "@hooks";
import { useEstimateEditorStore, EstimateSettings, CommentsDrawer } from "@tools"
import { CircularProgress, Grid } from "@material-ui/core";
import { Alert, Button, EstimateNameEditorV2 } from "@components";
import { VisibilityMode } from "./components/VisibilityMode";
import { SaveOutlined } from "@material-ui/icons";
import useStyle from "./TableToolbar.style";
import { saveTemplateStructureQuery } from "@query";

export const TemplateTableToolbar = observer(() => {
  const { t } = useTranslation();
  const editorStore = useEstimateEditorStore();
  const socket = useEditorWebsocket();
  const classes = useStyle();

  const [alertText, setAlertText] = useState("");
  const [isLoading, setLoadingState] = useState("");

  const {
    estimateName,
    estimateUsers,
  } = editorStore;

  const { isBusinessUser, isObserver, isManager } = useCheckEstimateEditorAccess(estimateUsers);

  const changeTemplateName = async (newName) => {
    if (estimateName !== newName) {
      await socket?.requestEstimateRename?.(editorStore.estimateId, newName);
      editorStore.setEstimateName(newName);
    }
  };
  
  const handleTemplateSave = async () => {
    setLoadingState(true);
    await saveTemplateStructureQuery(editorStore.estimateId);
    setLoadingState(false);
  }

  return (
    <Grid
      item container
      justifyContent="space-between"
      alignItems="flex-start"
      name="table_title"
      className="gap-3"
    >
      <Grid
        item container
        alignItems="center"
        className="w-max max-w-full"
      >
        <EstimateNameEditorV2
          name={estimateName}
          onSubmit={changeTemplateName}
          allowEdition useH1
        />
      </Grid>
      <Grid
        item container
        justifyContent="flex-end"
        className={classes.actionContainer}
      >
        { isBusinessUser && isObserver && <VisibilityMode /> }
        { isBusinessUser && isObserver && <EstimateSettings /> }
        {
          isManager &&
          <CommentsDrawer />
        }
        {
          isManager &&
          <Button
            icon={isLoading ? <CircularProgress size={24} className="text-alt" /> : <SaveOutlined />}
            onClick={handleTemplateSave}
            name={t("views.editor.dialogs.share.accept")}
            size="large"
            variant="contained"
            color="primary"
          >
            {t("views.editor.save")}
          </Button>
        }
        <Alert
          title={alertText}
          isOpen={!!alertText}
          onAccept={() => setAlertText("")}
          acceptText={t("common.close")}
        />
      </Grid>
    </Grid>
  );
});